import React, { PureComponent } from 'react';
import { NavLink, withRouter, matchPath } from "react-router-dom";
import Cookie from "js-cookie";
import TextTruncate from "./helpers/TextTruncate";
import IsEmpty from "./helpers/IsEmpty";
import RoutePath from './RoutePath';
import axios from 'axios';
import Config from './axios/Config';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import SwalToast from './helpers/SwalToast';
import { AuthorizationList, CanAccess } from './Authorization';

const animatedComponents = makeAnimated();

class Sidebar extends PureComponent {
    constructor(props) {
        super(props);
        let userdata = JSON.parse(Cookie.get('user'));
        this.state = {
            current_vendor: userdata.vendor ? { value: userdata.vendor.id, label: userdata.vendor.name } : null,
            vendors: [],
            total_death_certificates_not_yet_uploaded: 0,
            total_pending_dead: 0,
        }
    }

    componentDidMount() {
        this.getAdminVendors();
        this.getTotalDeathCertificatesNotYetUploaded();
        this.getTotalPendingDead();
    }

    getTotalDeathCertificatesNotYetUploaded = () => {
        axios.get(`${process.env.REACT_APP_BASE_API_URL}kambing/totalDeathCertificatesNotYetUploaded`, Config({
            Authorization: `Bearer ${Cookie.get('token')}`
        })).then(response => {
            this.setState({
                total_death_certificates_not_yet_uploaded: response.data.data
            });
        }).catch(error => {
            SwalToast.fire({
                icon: 'error',
                title: 'Whoops, something went wrong!'
            });
        });
    }

    getTotalPendingDead = () => {
        axios.get(`${process.env.REACT_APP_BASE_API_URL}kambing/totalPendingDead`, Config({
            Authorization: `Bearer ${Cookie.get('token')}`
        })).then(response => {
            this.setState({
                total_pending_dead: response.data.data
            });
        }).catch(error => {
            SwalToast.fire({
                icon: 'error',
                title: 'Whoops, something went wrong!'
            });
        });
    }

    handleLogout = async () => {
        if (!IsEmpty(Cookie.get('token'))) {
            // await invalidateFCMToken();
            Cookie.remove('token');
            Cookie.remove('refresh_token');
            Cookie.remove('authorizations');
            Cookie.remove('user');
            this.props.history.push(RoutePath.LOGIN);
        }
    }

    getAdminVendors = () => {
        let url = process.env.REACT_APP_BASE_API_URL + 'authorization/getAdminVendors'

        let headers = {
            Authorization: 'Bearer ' + Cookie.get('token')
        }
        axios.get(url, Config(headers)).then(res => {
            this.setState({
                vendors: res.data.data.map((value, index, array) => (
                    {
                        value: value.vendor.id,
                        label: value.vendor.name
                    }
                ))
            })
        }).catch((error) => {
            console.log(error)
        });
    }

    updateCurrentVendorId = (e) => {
        if (e) {
            axios.post(`${process.env.REACT_APP_BASE_API_URL}authorization/updateCurrentVendorId`, {
                vendor_id: e.value,
            }, Config({
                Authorization: `Bearer ${Cookie.get('token')}`
            })).then(response => {
                let userdata = JSON.parse(Cookie.get('user'));
                Cookie.set('user', {
                    email: userdata.email,
                    name: userdata.name,
                    user_type: userdata.user_type,
                    vendor: response.data.data
                });
                this.setState({
                    current_vendor: e,
                }, () => {
                    SwalToast.fire({
                        icon: 'success',
                        title: 'Updated Successfully!'
                    });
                    setTimeout(function () { window.location.reload(); }, 500);

                });
            }).catch(error => {
                SwalToast.fire({
                    icon: 'error',
                    title: 'Whoops, something went wrong!'
                });
            });
        }
    }

    render() {
        let userdata = JSON.parse(Cookie.get('user'));
        let master_data_route = (
            matchPath(this.props.match.path, RoutePath.SECTION) ||
            matchPath(this.props.match.path, RoutePath.SECTION_ADD) ||
            matchPath(this.props.match.path, RoutePath.SECTION_EDIT) ||
            matchPath(this.props.match.path, RoutePath.ADMIN) ||
            matchPath(this.props.match.path, RoutePath.ADMIN_ADD) ||
            matchPath(this.props.match.path, RoutePath.ADMIN_EDIT) ||
            matchPath(this.props.match.path, RoutePath.SECTION_TYPE) ||
            matchPath(this.props.match.path, RoutePath.SECTION_TYPE_ADD) ||
            matchPath(this.props.match.path, RoutePath.SECTION_TYPE_EDIT) ||
            matchPath(this.props.match.path, RoutePath.COUNTRY) ||
            matchPath(this.props.match.path, RoutePath.COUNTRY_ADD) ||
            matchPath(this.props.match.path, RoutePath.COUNTRY_EDIT) ||
            matchPath(this.props.match.path, RoutePath.VENDOR) ||
            matchPath(this.props.match.path, RoutePath.VENDOR_ADD) ||
            matchPath(this.props.match.path, RoutePath.VENDOR_EDIT) ||
            matchPath(this.props.match.path, RoutePath.COLOR) ||
            matchPath(this.props.match.path, RoutePath.GOAT_PEN) ||
            matchPath(this.props.match.path, RoutePath.GOAT_PEN_ADD) ||
            matchPath(this.props.match.path, RoutePath.GOAT_PEN_EDIT) ||
            matchPath(this.props.match.path, RoutePath.GOAT_TYPE) ||
            matchPath(this.props.match.path, RoutePath.SUPPLIER) ||
            matchPath(this.props.match.path, RoutePath.OWNER) ||
            matchPath(this.props.match.path, RoutePath.GOAT_BIRTH_TYPE) ||
            matchPath(this.props.match.path, RoutePath.GRADE) ||
            matchPath(this.props.match.path, RoutePath.FAMILY_NAME)
        );
        let goat_route = (
            matchPath(this.props.match.path, RoutePath.KAMBING) ||
            matchPath(this.props.match.path, RoutePath.KAMBING_ADD) ||
            matchPath(this.props.match.path, RoutePath.KAMBING_VIEW) ||
            matchPath(this.props.match.path, RoutePath.KAMBING_SOLD)
        );
        let food_route = (
            matchPath(this.props.match.path, RoutePath.FEEDING) ||
            matchPath(this.props.match.path, RoutePath.FEEDING_LOG) ||
            matchPath(this.props.match.path, RoutePath.FOOD) ||
            matchPath(this.props.match.path, RoutePath.FOOD_ADD) ||
            matchPath(this.props.match.path, RoutePath.FOOD_EDIT) ||
            matchPath(this.props.match.path, RoutePath.BUNKER) ||
            matchPath(this.props.match.path, RoutePath.BUNKER_ADD) ||
            matchPath(this.props.match.path, RoutePath.BUNKER_EDIT) ||
            matchPath(this.props.match.path, RoutePath.BUNKER_LOG)
        );
        let mating_route2 = (
            matchPath(this.props.match.path, RoutePath.MATING_PREPARATIONV2) ||
            matchPath(this.props.match.path, RoutePath.MATING_SCHEDULEV2) ||
            matchPath(this.props.match.path, RoutePath.MATING_FINISHED) ||
            matchPath(this.props.match.path, RoutePath.MATING_HISTORY)
        );
        let death_info = (
            matchPath(this.props.match.path, RoutePath.UPLOAD_DEATH_CERTIFICATE) ||
            matchPath(this.props.match.path, RoutePath.LIST_DEAD_GOAT) ||
            matchPath(this.props.match.path, RoutePath.DEAD_APPROVAL)
        );
        let report_route = (
            matchPath(this.props.match.path, RoutePath.REPORT) ||
            matchPath(this.props.match.path, RoutePath.REPORT_GENERAL) ||
            matchPath(this.props.match.path, RoutePath.REPORT_STOCK) ||
            matchPath(this.props.match.path, RoutePath.REPORT_MARRIAGE_JOURNAL) ||
            matchPath(this.props.match.path, RoutePath.REPORT_MARGA)
        );
        let setting_route = (
            matchPath(this.props.match.path, RoutePath.MENU_AUTHORIZATION) ||
            matchPath(this.props.match.path, RoutePath.CHANGE_PASSWORD) ||
            matchPath(this.props.match.path, RoutePath.GLOBAL_SETTING)
        );
        return (
            <div className="bgc-F0F6F9" id="sidebar-wrapper" style={{ width: '20rem', height: '100vh', overflow: 'auto' }}>
                <div className="sidebar-heading bgc-E5F0F5 d-flex align-items-center justify-content-center">
                    <h2 className="m-0 color-374650 font-weight-bold">GOMBEK</h2>
                </div>
                <div className="list-group bgc-F0F6F9 sidebar-wacvr">
                    <div className="border-bottom px-4 py-3">
                        <NavLink to={RoutePath.DASHBOARD} className="text-decoration-none color-374650" activeClassName={""}>
                            <TextTruncate className="color-374650 m-0" lineClamp={1}>{userdata.name}</TextTruncate>
                            <p className="color-EC9700 font-weight-bold m-0" style={{ fontSize: '0.9rem' }}>{userdata.user_type}</p>
                        </NavLink>
                        <div className="form-group pt-3">
                            {/* <label htmlFor="add-goat-pen-id" className="color-374650">Vendor</label> */}
                            <Select
                                components={animatedComponents}
                                isClearable
                                required
                                id="add-goat-pen-id"
                                options={this.state.vendors}
                                className="w-100"
                                value={this.state.current_vendor}
                                onChange={event => this.updateCurrentVendorId(event)}
                                placeholder="Select Vendor"
                            />
                        </div>
                    </div>

                    <div className="p-2">
                        <NavLink to={RoutePath.DASHBOARD} className="text-decoration-none color-374650 btn-block p-3">
                            <i className="fas fa-cog"></i>&nbsp; Dashboard
                        </NavLink>
                        <>
                            <a href="#master-data-collapse" className={`text-decoration-none color-374650 btn-block p-3 ${master_data_route && 'active'}`} data-toggle="collapse" aria-expanded="false">
                                <div className="row">
                                    <div className="col-10">
                                        <i className="fas fa-cog"></i>&nbsp; Master Data
                                    </div>
                                    <div className="col-2">
                                        <i className="fas fa-chevron-down"></i>
                                    </div>
                                </div>
                            </a>
                            <div className={`collapse pl-4 ${master_data_route ? 'show' : ''}`} id="master-data-collapse">
                                <CanAccess role={AuthorizationList.master_data_color_view} yes={<NavLink to={RoutePath.COLOR} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName="font-weight-bold">
                                    Color
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.master_data_country_view} yes={<NavLink to={RoutePath.COUNTRY} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName="font-weight-bold">
                                    Country
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.master_data_goat_pen_view} yes={<NavLink to={RoutePath.GOAT_PEN} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName="font-weight-bold">
                                    Kandang
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.master_data_grade_view} yes={<NavLink to={RoutePath.GOAT_TYPE} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName="font-weight-bold">
                                    Goat Type
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.master_data_goat_birth_type_view} yes={<NavLink to={RoutePath.GOAT_BIRTH_TYPE} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName="font-weight-bold">
                                    Goat Birth Type
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.master_data_family_name_view} yes={<NavLink to={RoutePath.FAMILY_NAME} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName="font-weight-bold">
                                    Marga
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.master_data_grade_view} yes={<NavLink to={RoutePath.GRADE} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName="font-weight-bold">
                                    Grade
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.master_data_section_view} yes={<NavLink to={RoutePath.SECTION} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName="font-weight-bold">
                                    Section
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.master_data_section_type_view} yes={<NavLink to={RoutePath.SECTION_TYPE} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName="font-weight-bold">
                                    Section Type
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.master_data_owner_view} yes={<NavLink to={RoutePath.OWNER} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName="font-weight-bold">
                                    Owner
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.master_data_supplier_view} yes={<NavLink to={RoutePath.SUPPLIER} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName="font-weight-bold">
                                    Supplier
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.master_data_vendor_view} yes={<NavLink to={RoutePath.VENDOR} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName="font-weight-bold">
                                    Unit
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.master_data_admin_view} yes={<NavLink to={RoutePath.ADMIN} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName="font-weight-bold">
                                    Admin
                                </NavLink>} />
                            </div>
                        </>
                        <>
                            <a href="#goat-collapse" className={`text-decoration-none color-374650 btn-block p-3 ${goat_route && 'active'}`} data-toggle="collapse" aria-expanded="false">
                                <div className="row">
                                    <div className="col-10">
                                        <i className="fas fa-cog"></i>&nbsp; Kambing
                                    </div>
                                    <div className="col-2">
                                        <i className="fas fa-chevron-down"></i>
                                    </div>
                                </div>
                            </a>
                            <div className={`collapse pl-4 ${goat_route ? 'show' : ''}`} id="goat-collapse">
                                <CanAccess role={AuthorizationList.kambing_add} yes={<NavLink to={RoutePath.KAMBING_ADD} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    Tambah Kambing
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.kambing_view} yes={<NavLink to={RoutePath.KAMBING_VIEW} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    Semua Kambing
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.kambing_view} yes={<NavLink to={RoutePath.KAMBING_SOLD} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    Kambing Terjual
                                </NavLink>} />
                            </div>
                        </>

                        <>
                            <a href="#food-collapse" className={`text-decoration-none color-374650 btn-block p-3 ${food_route && 'active'}`} data-toggle="collapse" aria-expanded="false">
                                <div className="row">
                                    <div className="col-10">
                                        <i className="fas fa-cog"></i>&nbsp; Makanan
                                    </div>
                                    <div className="col-2">
                                        <i className="fas fa-chevron-down"></i>
                                    </div>
                                </div>
                            </a>
                            <div className={`collapse pl-4 ${food_route ? 'show' : ''}`} id="food-collapse">
                                <CanAccess role={AuthorizationList.food_feeding_view} yes={<NavLink to={RoutePath.FEEDING} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    Beri Makan
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.food_food_view} yes={<NavLink to={RoutePath.FOOD} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    Makanan
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.food_bungker_view} yes={<NavLink to={RoutePath.BUNKER} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    Bungker
                                </NavLink>} />
                            </div>
                        </>

                        {/* <>
                            <a href="#mating-collapse" className={`text-decoration-none color-374650 btn-block p-3 ${mating_route && 'active'}`} data-toggle="collapse" aria-expanded="false">
                                <div className="row">
                                    <div className="col-10">
                                        <i className="fas fa-cog"></i>&nbsp; Perkawinan
                                    </div>
                                    <div className="col-2">
                                        <i className="fas fa-chevron-down"></i>
                                    </div>
                                </div>
                            </a>
                            <div className={`collapse pl-4 ${mating_route ? 'show' : ''}`} id="mating-collapse">
                                <CanAccess role={AuthorizationList.mating_preparation} yes={<NavLink to={RoutePath.MATING_PREPARATION} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    Persiapan
                                </NavLink>}/>
                                <CanAccess role={AuthorizationList.mating_plan_view} yes={<NavLink to={RoutePath.MATING_SCHEDULE} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    Perkawinan
                                </NavLink>} />
                            </div>
                        </> */}
                        <>
                            <a href="#mating-collapse2" className={`text-decoration-none color-374650 btn-block p-3 ${mating_route2 && 'active'}`} data-toggle="collapse" aria-expanded="false">
                                <div className="row">
                                    <div className="col-10">
                                        <i className="fas fa-cog"></i>&nbsp; Perkawinan
                                    </div>
                                    <div className="col-2">
                                        <i className="fas fa-chevron-down"></i>
                                    </div>
                                </div>
                            </a>
                            <div className={`collapse pl-4 ${mating_route2 ? 'show' : ''}`} id="mating-collapse2">
                                <CanAccess role={AuthorizationList.mating_preparation} yes={<NavLink to={RoutePath.MATING_PREPARATIONV2} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    Persiapan
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.mating_plan_view} yes={<NavLink to={RoutePath.MATING_SCHEDULEV2} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    Perkawinan
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.mating_plan_view} yes={<NavLink to={RoutePath.MATING_FINISHED} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    Selesai
                                </NavLink>} />
                                <CanAccess role={AuthorizationList.mating_plan_view} yes={<NavLink to={RoutePath.MATING_HISTORY} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    History Perkawinan
                                </NavLink>} />
                            </div>
                        </>
                        <>
                            <a href="#dead-collapse" className={`text-decoration-none color-374650 btn-block p-3 ${death_info && 'active'}`} data-toggle="collapse" aria-expanded="false">
                                <div className="row">
                                    <div className="col-10 d-flex align-items-center">
                                        <i className="fas fa-cog"></i>&nbsp; Info Kematian

                                        <div className={`ml-1 rounded-circle d-flex justify-content-center align-items-center ${this.state.total_death_certificates_not_yet_uploaded + this.state.total_pending_dead !== 0 && 'bgc-EB2424'}`} style={{ width: '1.4rem', height: '1.4rem' }}>
                                            <p className={`m-0 small ${this.state.total_death_certificates_not_yet_uploaded + this.state.total_pending_dead !== 0 && 'text-white'}`} style={this.state.total_death_certificates_not_yet_uploaded + this.state.total_pending_dead === 0 ? { opacity: 0 } : {}}>{this.state.total_death_certificates_not_yet_uploaded + this.state.total_pending_dead}</p>
                                        </div>
                                    </div>
                                    <div className="col-2s">
                                        <i className="fas fa-chevron-down"></i>
                                    </div>
                                </div>
                            </a>
                            <div className={`collapse pl-4 ${death_info ? 'show' : ''}`} id="dead-collapse">
                                <CanAccess role={AuthorizationList.kambing_approve_kematian} yes={<NavLink to={RoutePath.DEAD_APPROVAL} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    <div className="row">
                                        <div className="col-9">
                                            Menunggu Persetujuan
                                        </div>
                                        <div className="col-3">
                                            <div className={`rounded-circle d-flex justify-content-center align-items-center ${this.state.total_pending_dead !== 0 && 'bgc-EB2424'}`} style={{ width: '1.4rem', height: '1.4rem' }}>
                                                <p className={`m-0 small ${this.state.total_pending_dead !== 0 && 'text-white'}`} style={this.state.total_pending_dead === 0 ? { opacity: 0 } : {}}>{this.state.total_pending_dead}</p>
                                            </div>
                                        </div>
                                    </div>
                                </NavLink>} />

                                <CanAccess role={AuthorizationList.kambing_edit} yes={<NavLink to={RoutePath.UPLOAD_DEATH_CERTIFICATE} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    <div className="row">
                                        <div className="col-9">
                                            Upload Sertifikat
                                        </div>
                                        <div className="col-3">
                                            <div className={`rounded-circle d-flex justify-content-center align-items-center ${this.state.total_death_certificates_not_yet_uploaded !== 0 && 'bgc-EB2424'}`} style={{ width: '1.4rem', height: '1.4rem' }}>
                                                <p className={`m-0 small ${this.state.total_death_certificates_not_yet_uploaded !== 0 && 'text-white'}`} style={this.state.total_death_certificates_not_yet_uploaded === 0 ? { opacity: 0 } : {}}>{this.state.total_death_certificates_not_yet_uploaded}</p>
                                            </div>
                                        </div>
                                    </div>
                                </NavLink>} />


                                <CanAccess role={AuthorizationList.mating_plan_view} yes={<NavLink to={RoutePath.LIST_DEAD_GOAT} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    Daftar Kambing Mati
                                </NavLink>} />
                            </div>
                        </>
                        <>
                            <a href="#report-collapse" className={`text-decoration-none color-374650 btn-block p-3 ${report_route && 'active'}`} data-toggle="collapse" aria-expanded="false">
                                <div className="row">
                                    <div className="col-10">
                                        <i className="fas fa-cog"></i>&nbsp; Report
                                    </div>
                                    <div className="col-2">
                                        <i className="fas fa-chevron-down"></i>
                                    </div>
                                </div>
                            </a>
                            <div className={`collapse pl-4 ${report_route ? 'show' : ''}`} id="report-collapse">
                                <NavLink to={RoutePath.REPORT_GENERAL} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    General
                                </NavLink>
                                <NavLink to={RoutePath.REPORT_STOCK} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    Stock
                                </NavLink>
                                <NavLink to={RoutePath.REPORT_MARRIAGE_JOURNAL} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    Marriage Journal
                                </NavLink>
                                <NavLink to={RoutePath.REPORT_MARGA} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    Marga
                                </NavLink>
                            </div>
                        </>
                        <>
                            <a href="#settings-collapse" className={`text-decoration-none color-374650 btn-block p-3 ${setting_route && 'active'}`} data-toggle="collapse" aria-expanded="false">
                                <div className="row">
                                    <div className="col-10">
                                        <i className="fas fa-cog"></i>&nbsp; Setting
                                    </div>
                                    <div className="col-2">
                                        <i className="fas fa-chevron-down"></i>
                                    </div>
                                </div>
                            </a>
                            <div className={`collapse pl-4 ${setting_route ? 'show' : ''}`} id="settings-collapse">
                                <CanAccess role={AuthorizationList.setting_menu_authorization_view} yes={<NavLink to={RoutePath.MENU_AUTHORIZATION} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    Menu Authorization
                                </NavLink>} />
                                <NavLink to={RoutePath.CHANGE_PASSWORD} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    Change Password
                                </NavLink>
                                <NavLink to={RoutePath.GLOBAL_SETTING} className="text-decoration-none color-374650 btn-block px-3 py-1" activeClassName={"font-weight-bold"}>
                                    Global Setting
                                </NavLink>
                            </div>
                        </>

                        <NavLink to={RoutePath.LOGIN} onClick={this.handleLogout} className="text-decoration-none color-374650 btn-block p-3" activeClassName={""}>
                            <i className="fas fa-sign-out-alt"></i>&nbsp; Logout
                        </NavLink>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Sidebar);